import { FONTS, COLORS } from '../../../../../../constants';

// eslint-disable-next-line no-unused-vars
const styles = theme => {
  // take mobile-first approach to do the styling

  const minSm = theme.breakpoints.up('sm');
  const minMd = theme.breakpoints.up('md');

  return {
    root: {
      backgroundColor: COLORS.GREY_DARK,
    },
    inner: {
      margin: '0 auto',
      maxWidth: 1200,
      padding: '20px 20px',
      [minMd]: {
        padding: '40px 30px',
      },
    },
    heading: {
      marginTop: 0,
      textAlign: 'center',
    },
    statusBox: {
      width: 200,
      backgroundColor: COLORS.YELLOW_DARK,
      color: COLORS.GREY_DARK,
      margin: '30px auto',
      padding: '5px 10px',
      textAlign: 'center',
      fontSize: '0.625rem',
    },
    stepper: {
      display: 'none',
      [minSm]: {
        display: 'block',
      },
    },
    warningMessage: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      fontFamily: FONTS.SECONDARY,
      fontWeight: 400,
      color: COLORS.YELLOW_DARK,
      '& > span': {
        color: COLORS.WHITE,
        marginLeft: 8,
      },
      [minSm]: {
        display: 'none',
      },
    },
  };
};

export default styles;
